<div class="rad-dropdown-select-container" *ngIf="options.length > 1">
  <rad-select 
    #dropdown
    class="rad-theme--light"
    [formControl]="selectControl"
    [attr.multiple]="isMultiple"
    placeholder="Multiple Kits"
    label-width="150px"
    [attr.label]="label">
    <rad-option 
      *ngFor="let option of options"
      
      [attr.value]="option.value"
      [attr.label]="option.text">
      {{ option.text }}
    </rad-option>
  </rad-select>
</div>

<div class="rad-dropdown-select-container" *ngIf="options.length === 1">
    {{options[0].text}}
</div>


<div class="rad-dropdown-select-container no-options" *ngIf="options.length === 0">
  <span class="no-options-text">No options available</span>
</div>
